import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { device } from '../../../atoms/Utlis/media';

export const PageContainer = styled.div`
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-sizing: border-box;
  @media ${device.tablet} {
    padding: 20px 16px;
  }
`;

export const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #ffffff;
  cursor: pointer;
  transition: all 0.15s ease;
  margin-bottom: 8px;
  &:hover {
    background: #f7f7f7;
    transform: translateY(-1px);
  }
`;

export const Title = styled.h1`
  margin: 0;
  margin-top: 10px;
  font-family: 'Urbanist', sans-serif;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.05;
  color: #171717;
  @media ${device.tablet} {
    font-size: 24px;
  }
`;

export const Subtitle = styled.p`
  margin: 0px 0 0 0;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: rgba(23, 23, 23, 0.65);
`;

export const ErrorText = styled.div`
  padding: 12px 14px;
  border-radius: 10px;
  background: #fef2f2;
  color: #dc2626;
  font-family: 'Urbanist', sans-serif;
  font-size: 14px;
  font-weight: 600;
`;

export const RefreshButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  &:hover {
    color: #C94DAA;
    border-color: rgba(201, 77, 170, 0.3);
    box-shadow: 0px 4px 12px rgba(201, 77, 170, 0.1);
  }
  &:active svg {
    transform: rotate(180deg);
    transition: transform 0.4s ease;
  }
`;


export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  width: 90%;
  max-width: 460px;
  padding: 28px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  font-family: 'Urbanist', sans-serif;
  position: relative;
  animation: slideUp 0.2s ease-out;
  @keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s;
  &:hover {
    color: #374151;
  }
`;

export const ModalTitle = styled.h3`
  margin: 0 0 20px 0;
  font-family: 'Urbanist', sans-serif;
  font-size: 20px;
  font-weight: 800;
  color: #171717;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 10px;
  border: none;
  font-family: 'Urbanist', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: white;
  background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
  cursor: pointer;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.95;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  padding: 10px 20px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-family: 'Urbanist', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #f9fafb;
  }
`;
